export default "__VITE_ASSET__hLx_gXRo__"